import Muuri from 'muuri'
import debounce from 'lodash/debounce'
import deburr from 'lodash/deburr'
import includes from 'lodash/includes'
import './src/dialog'

const gridEl = document.getElementById('items-grid')
const gridItems = document.querySelectorAll('.filter-item')
const searchBar = document.getElementById('items-search')
const noResults = document.getElementById('items-no-results')

gridEl.classList.remove('flex')
gridEl.classList.remove('flex-wrap')

gridItems.forEach((item) => {
    item.classList.add('absolute')
})

const grid = new Muuri(gridEl)

grid.on('layoutEnd', (items) => {
    if (items.length === 0) {
        noResults.classList.remove('hidden')
    } else {
        noResults.classList.add('hidden')
    }
})

searchBar.addEventListener('keyup', debounce(searchItems, 100))

window.addEventListener('popstate', () => searchItems())

window.onload = searchItems

function searchItems() {
    const searchQuery = normalize(searchBar.value)

    grid.filter((item) => {
        const element = item.getElement()
        const params = parseSearch()

        if (searchQuery.length > 0) {
            if (
                !includes(normalize(element.dataset.title), searchQuery) &&
                !includes(normalize(element.dataset.content), searchQuery)
            ) {
                return false
            }
        }

        if (Object.keys(params).length > 0) {
            let passedFilters = []

            Object.keys(params).forEach((slug) => {
                let passedTerms = 0
                const elementData = JSON.parse(element.dataset[slug])
                params[slug].forEach((search) => {
                    if (elementData.includes(search)) {
                        passedTerms += 1
                    }
                })

                passedFilters.push(passedTerms > 0)
            })

            // každá faseta musí mít alespoň jednu shodu
            return passedFilters.every((v) => v === true)
        }

        return true
    })
}

function parseSearch() {
    const urlParams = new URLSearchParams(window.location.search)
    const filterSlugs = gridEl.dataset.filters.split(',')
    const params = {}

    filterSlugs.forEach((slug) => {
        slug = slug.trim()
        if (urlParams.has(slug) && urlParams.get(slug).length !== 0) {
            params[slug] = urlParams.get(slug).split(',')
        }
    })

    return params
}

function normalize(str) {
    return deburr(str.toString().trim().toLowerCase())
}
